import { render, staticRenderFns } from "./encodersidebar.vue?vue&type=template&id=289a015a&scoped=true&"
import script from "./encodersidebar.vue?vue&type=script&lang=js&"
export * from "./encodersidebar.vue?vue&type=script&lang=js&"
import style0 from "./encodersidebar.vue?vue&type=style&index=0&id=289a015a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a015a",
  null
  
)

export default component.exports